<template>
  <div id="month-selector">
    <VueSlideBar
      :min="1"
      :max="12"
      :value="value"
      :range="range"
      :show-tooltip="false"
      :paddingless="true"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import VueSlideBar from 'vue-slide-bar';

export default {
  name: 'MonthSelector',

  props: [
    'value',
  ],

  components: {
    VueSlideBar,
  },

  data() {
    return {
      range: [
        { label: 'Ene' },
        { label: 'Feb' },
        { label: 'Mar' },
        { label: 'Abr' },
        { label: 'May' },
        { label: 'Jun' },
        { label: 'Jul' },
        { label: 'Ago' },
        { label: 'Sep' },
        { label: 'Oct' },
        { label: 'Nov' },
        { label: 'Dic' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

#month-selector {
  background-color: $color-clear;
  border-radius: $border-radius;
  padding: 0 $map-components-margin;

  #wrap {
    padding-top: 10px;
  }
}
</style>
